import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  newsfeed: [] as Metricate.Newsfeed[],
  notifications: [],
}

const companySlice = createSlice({
  name: "comms",
  initialState,
  reducers: {
    setNewsfeed: (state, action) => {
      state.newsfeed = action.payload
    },
    setNotifications: (state, action) => {
      state.notifications = action.payload
    },
  },
})

export const { setNewsfeed, setNotifications } = companySlice.actions
export default companySlice.reducer
